import React from 'react';
import ReactModal from 'react-modal';
import Select from 'react-select';
import { StripeProvider, Elements, injectStripe } from 'react-stripe-elements';

import AddCardForm from '../AddCardForm';
import AddPurchaseOrderForm from '../AddPurchaseOrderForm';
import config from '../../../../src/config';

const InjectedAddCardForm = injectStripe(AddCardForm);

class AddCardModal extends React.Component {
  constructor(props) {
    super(props);
    const cardOption = { label: 'Credit', value: 'Credit' };
    const poOption = { label: 'Purchase Order', value: 'Purchase Order' };
    this.state = {};
    if (props.cardCount > 0) {
      this.state.value = 'Credit';
      this.state.options = [cardOption];
    } else if (props.purchaseOrderCount > 0) {
      this.state.value = 'Purchase Order';
      this.state.options = [poOption];
    } else {
      this.state = { value: 'Credit' };
      this.state.options = [cardOption, poOption];
    }
  }

  handlePaymentTypeChange = (e) => {
    this.setState( { value: e });
  }

  render() {
    const {
      showModal,
      contentLabel,
      handleCloseModal,
    } = this.props;
    const value = this.state.value;

    const paymentComponent = (value === 'Credit')
      ? <StripeProvider apiKey={config.stripeKey.public}>
          <Elements>
            <InjectedAddCardForm closeModal={handleCloseModal} />
          </Elements>
        </StripeProvider>
      : <AddPurchaseOrderForm closeModal={handleCloseModal} />
    ;

    return (
      <ReactModal
        isOpen={showModal}
        contentLabel={contentLabel}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            overflowY: 'auto',
          },
          content: {
            marginLeft: 'auto',
            marginRight: 'auto',
            padding: 0,
            border: 'none',
            bottom: 'auto',
            borderRadius: 4,
            maxWidth: '40vw',
          },
        }}
      >
        <div className="modal-content">
          <div className="modal-header" style={{ backgroundColor: '#eee' }}>
            <h5 className="modal-title">{contentLabel}</h5>
            <button
              onClick={handleCloseModal}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i
                className="fa fa fa-times"
                style={{ fontSize: '1.3em', color: '#808080' }}
              />
            </button>
          </div>
          <div style={{ marginTop: 16, marginBottom: 16, marginLeft: 16 }}>
            <label htmlFor="payment_type">Payment Type</label>
            <Select
              name="payment_type"
              // className="form-control"
              style={{ maxWidth: 500 }}
              simpleValue
              autoBlur
              clearable={false}
              // searchable
              matchProp={'label'}
              matchPos={'any'}
              onBlurResetsInput={false}
              onCloseResetsInput={false}
              onBlurSelectsFocusedOption
              backspaceRemoves={false}
              cache={false}
              multi={false}
              options={this.state.options}
              value={value}
              onChange={e => {
                this.handlePaymentTypeChange(e);
              }}
            >
            </Select>
          </div>
          <div className="modal-body">
            {paymentComponent}
          </div>
        </div>
      </ReactModal>
    );
  }
}

export default class AddCardButton extends React.Component {
  state = {
    open: false,
  };

  handleClick = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    return (
      <div>
        <button
          type="button"
          className="btn btn-primary btn-sm mb-2"
          onClick={this.handleClick}
        >
          <i
            className="fa fa-plus"
            aria-hidden="true"
            style={{ marginRight: 5 }}
          />
          Add a Payment Method
        </button>
        <AddCardModal
          showModal={this.state.open}
          handleCloseModal={this.handleClose}
          cardCount={this.props.cardCount}
          purchaseOrderCount={this.props.purchaseOrderCount}
          contentLabel={'Add a Payment Method'}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/ModalButtons/AddCard.js